import { observer } from 'mobx-react-lite';
import "./WebHomePage.css";  
import { useEffect, useState } from 'react';
import { ScrollRestoration, useLocation, useNavigate } from 'react-router-dom';
import { useStore } from '../../app/stores/rootStore';
export default observer(function AboutUsComponent() {
    const { commonStore,modalStore } = useStore();
    const currentyear = new Date().getFullYear();
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    const [toggleBtn, setToggleBtn] = useState(true);
  const toggle = () => setToggleBtn(val => !val);
    return (
<section data-bs-version="5.1" className="article03 healthm5 cid-uAXw0YQ0CC" id="article03-m">

<div className="container-fluid">
    <div className="row">
        <div className="col-12">
            <div className="content-wrapper">
                <div className="content-wrap">  
                    <div className="desc-wrapper">
                        <p className="mbr-desc mbr-fonts-style display-4">
                            About Us</p>
                    </div>
                    <h2 className="mbr-section-title mbr-fonts-style display-2">Voguish Trendy Couture Store</h2>
                    <p className="mbr-text mbr-fonts-style display-7">Welcome to Voguish Trendy Couture, your premier destination for exquisite Maheshwari and Chanderi handloom saree collections. We are passionate about celebrating India’s rich textile heritage by offering beautifully crafted sarees that blend traditional artistry with contemporary style. Our curated selections showcase the finest craftsmanship, vibrant colors, and luxurious fabrics that are perfect for any occasion. At Voguish Trendy Couture, we believe that every saree tells a story — of culture, craftsmanship, and elegance. Explore our collection and experience the timeless beauty of handloom sarees, designed to make you look and feel exceptional.</p>
                    <div className="mbr-section-btn"><a className="btn btn-primary display-4" style={{cursor:'pointer'}} onClick={()=>{                                                
                            navigate("/contactus");
                        }}>
                            Connect Us</a></div>
                </div>
                <div className="image-wrapper">                
                <video  controls style={{marginTop:'110px',height:'350px',textAlign:'center', marginRight: '20px',marginLeft:'20px', marginBottom:'20px'}}>
        <source src="assets/images/chanderi-saree-manifacturing.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>                    
                </div>
            </div>
        </div>
    </div>
</div>
</section>
    )
})